/**
 * Where to send someone for Best Buy pickup in a state (#333).
 *
 * The state's fixed ZIP is only where the poller starts looking; the stock can
 * be hundreds of miles away (Florida's is Tallahassee, and on 2026-09-19 the
 * only Florida store with SKU 6614787 was Palm Beach Gardens, 33410). When the
 * poller recorded the store that answered, its ZIP and city win. The city is
 * only returned together with the store's ZIP, so the two always agree. The
 * site shows the ZIP alone (owner's call, #337: the city was cramped).
 */
export function bestBuyPickupLocation(state, stateZipCodes = {}) {
    const fallbackZip = state?.zipCode || stateZipCodes[state?.stateName] || '';
    if (!state?.available) {
        return { zipCode: fallbackZip, city: '' };
    }

    const storeZip = String(state.pickupStoreZip || '').trim();
    if (!/^\d{5}$/.test(storeZip)) {
        return { zipCode: fallbackZip, city: '' };
    }

    return { zipCode: storeZip, city: String(state.pickupStoreCity || '').trim() };
}
